import React from 'react';

const InputWrapper = ({
  width = 'inherit',
  label = '',
  children,
  required = false,
}) => (
  <div className="col-auto" style={{ width, margin: '3px 0' }}>
    {label.length > 0 && (
      <label className="label-block">
        {label} {required && <span className="required">*</span>}
      </label>
    )}
    {children}
  </div>
);

export default InputWrapper;



// WEBPACK FOOTER //
// ./foody/src/components/Common/InputWrapper.jsx